import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'

import { getCountries } from '../../modules/countries'
import { getKyc, submitKyc } from '../../modules/users/current/kyc'
import currentUserSelector from '../../selectors/current_user'
import jsonSelector from '../../selectors/json'

const mapStateToProps = state => ({
  countries: jsonSelector('countries')(state),
  ...formValueSelector('kyc')(state, 'document_front', 'document_back', 'document_selfie'),
  loading: state.users.current.kyc.loading,
  initialValues: { ...jsonSelector('users.current.kyc')(state), agreement: true },
  current_user: currentUserSelector(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getCountries, getKyc, submitKyc }, dispatch)

export default WrappedComponent =>
  connect(mapStateToProps, mapDispatchToProps)(
    class Wrapper extends Component {
      componentDidMount() {
        const { getCountries, getKyc } = this.props
        getCountries()
        getKyc()
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  )



// WEBPACK FOOTER //
// ./src/containers/hocs/kyc.js